<div class="dialog-meetings-widget">
  <!-- Tabs: only render the bar when the user has meetings in more than one scope -->
  <div
    class="btn-group dm-tabs custom-width"
    role="group"
    aria-label="Dialog meeting scope"
    *ngIf="showManagerTab && showEmployeeTab"
  >
    <button
      type="button"
      class="btn"
      [ngClass]="{
        'btn-primary': activeScope === 'manager',
        'btn-outline-secondary': activeScope !== 'manager'
      }"
      (click)="setScope('manager')"
    >
      <span translate>APPRAISAL_MANAGER_MEETINGS</span>
    </button>
    <button
      type="button"
      class="btn"
      [ngClass]="{
        'btn-primary': activeScope === 'employee',
        'btn-outline-secondary': activeScope !== 'employee'
      }"
      (click)="setScope('employee')"
    >
      <span translate>APPRAISAL_MY_MEETINGS</span>
    </button>
  </div>

  <!-- Chart + custom legend -->
  <div class="dm-body" *ngIf="shouldShow | async">
    <div class="dm-chart-wrapper">
      <ngx-charts-bar-vertical
        [results]="chartData"
        [scheme]="colorScheme"
        [xAxis]="showXAxis"
        [yAxis]="showYAxis"
        [legend]="showLegend"
        [gradient]="gradient"
        [showXAxisLabel]="false"
        [showYAxisLabel]="false"
        [yAxisTickFormatting]="yAxisTickFormatting"
        (select)="onSelect($event)"
      >
      </ngx-charts-bar-vertical>
    </div>

    <ul class="dm-legend">
      <li *ngFor="let item of legendItems" class="dm-legend-item">
        <span class="dm-legend-dot" [style.background]="item.color"></span>
        <span class="dm-legend-label">{{ item.label }}</span>
      </li>
    </ul>
  </div>

  <div *ngIf="isLoading" class="dm-loading">
    <i class="fa fa-spinner fa-spin"></i>
  </div>
</div>
